import * as React from 'react'
import { PreviewComponentType } from './types'

type PreviewerContextType = {
  previewComponent: PreviewComponentType | null
  setPreviewComponent?: React.Dispatch<React.SetStateAction<PreviewComponentType | null>>
  onBoardingCompleted?: boolean
  setOnBoardingCompleted?: React.Dispatch<React.SetStateAction<boolean>>
}

export const PreviewerContext = React.createContext<PreviewerContextType>({
  previewComponent: null,
  setPreviewComponent: () => null,
  onBoardingCompleted: false,
  setOnBoardingCompleted: () => false
})

export const usePreviewerContext = () => React.useContext(PreviewerContext)

const PreviewerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [previewComponent, setPreviewComponent] = React.useState<PreviewComponentType | null>(null)
  const [onBoardingCompleted, setOnBoardingCompleted] = React.useState<boolean>(false)

  return (
    <PreviewerContext.Provider
      value={{
        previewComponent,
        setPreviewComponent,
        onBoardingCompleted,
        setOnBoardingCompleted
      }}
    >
      {children}
    </PreviewerContext.Provider>
  )
}

export default PreviewerProvider
